import React, { Component } from 'react';
import _ from 'lodash';

import GroupDataForm from './GroupDataForm';
import GroupLDAPForm from './GroupLDAPForm';

import GroupStore from '../../../stores/GroupStore';
import { groupVariables } from '../../Variable';
import Loading from '../../Loading';

import ErrorMessage from '../../ErrorMessage';

const dataMode = 'data';
const ldapMode = 'ldap';

class GroupForm extends Component {
	constructor(props){
		super(props)

		this.state = {
			loading: false,
			activeMode: 'data',
			group: groupVariables(),
			error_message: ''
		}

		this.handleChange = this.handleChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.loadData = this.loadData.bind(this);
	}

	componentWillMount(){
		if (this.props.action === 'edit') {
			this.loadData(this.props.focus.id);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.focus.id !== nextProps.focus.id && nextProps.action === 'edit'){
			this.loadData(nextProps.focus.id);
		}
	}

	loadData(group_id){
		this.setState({loading: true});

		GroupStore.request({id: group_id, action: 'edit'}).then((resp)=>{
			var group = _.get(resp.data, 'data', {});
			this.setState({
				loading: false,
				group: {
					code: group.attributes.code,
					name: group.attributes.name,
					active_directories: group.attributes.active_directories
				}
			})
		}).then(()=>{
			this.setState({loading: false});
		})
	}

	handleChange(group){
		this.setState({group: group});
	}

	handleSave(event){
		event.preventDefault();
		var self = this;
		var active_directory_ids = _.map(this.state.group.active_directories, 'id', []);

		var id = null;
		var group_attributes = {}
		if (this.props.action === 'edit') {
			id = this.props.focus.id;
			group_attributes = {
				code: this.state.group.code,
				name: this.state.group.name,
				active_directory_ids: active_directory_ids
			}
		} else {
			group_attributes = {
				code: this.state.group.code,
				name: this.state.group.name,
				active_directory_ids: active_directory_ids,
				parent_id: this.props.focus.id
			}
		}

		GroupStore.save(id, {
			group: group_attributes
		}).then(()=>{
			this.props.onCloseAndReloadData()
		}, function(error){
			var error_message = _.get(error.response.data, 'error.message', '');
			self.setState({error_message: error_message});
		});
	}

	render(){
		var ldapSize = _.size(this.state.group.active_directories);
		return (
			<form onSubmit={this.handleSave}>
				{this.state.error_message && <ErrorMessage error_message={this.state.error_message} />}

				<ul className="nav nav-tabs nav-fill" id="ManageUser" role="tablist">
				  	<li className="nav-item">
						<span className={`nav-link pointer ${(this.state.activeMode === dataMode) && 'active'}`} 
						onClick={()=>this.setState({activeMode: dataMode})}>
							Data
						</span>
				  	</li>
				  	<li className="nav-item">
						<span className={`nav-link pointer ${(this.state.activeMode === ldapMode) && 'active'}`} 
						onClick={()=>this.setState({activeMode: ldapMode})}>
							LDAP
							{ldapSize > 0 && (
				    			<em>&nbsp;({ldapSize})</em>
				    		)}
						</span>
				  	</li>
				</ul>
				<div className="tab-content mt-4" id="ManageUserContent">
					{this.state.loading && (
						<Loading />
					)}

				  	<div className={`tab-pane fade ${(this.state.activeMode === dataMode) && 'show active'}`}>
				  		<GroupDataForm 
				  			group={this.state.group} 
				  			handleChangeData={this.handleChange} />
				  	</div>
				  	<div className={`tab-pane fade ${(this.state.activeMode === ldapMode) && 'show active'}`}>
				  		<GroupLDAPForm 
				  			group={this.state.group}
				  			handleChangeData={this.handleChange}
				  			active_directories={this.props.active_directories} />
				  	</div>
				</div>
				<div className="modal-footer row">
					<button type='submit' className="btn btn-primary pointer">Save changes</button>
					<button type='button' className="btn btn-secondary pointer" onClick={()=>this.props.onClose()}>Close</button>
				</div>
			</form>
		)
	}
}

export default GroupForm;


// WEBPACK FOOTER //
// ./src/components/manage_users/businesses/GroupForm.js